import Utils from "../services/utils-service.js";
import Pet from "../services/pet-service.js";
import Funnel from "../services/funnel-service.js";
import router from "../router.js";
import { throwError } from "../errors.js";

const puid = 'pg_pets_summary';

export default {
    actions: {
        fetchCoverage(context, data) {
            const $fs = new Funnel({ ctx: context });

            document.querySelectorAll('.coverage-card').forEach(element => {
                element.classList.add('loading');
            });

            fetch(`/api?req=pet&action=get-coverage&limit=${data.limit}&deductible=${data.deductible}&reimbursement=${data.reimbursement}&wellness=${data.wellness}&plan=${data.plan}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' }
            }).then(
                response => response.json()
            ).then(res => {
                console.log('Success:', res);
                if (Object.keys(res.data).length > 0) {
                    $fs.commitMutations(res.data);

                    document.querySelectorAll('.coverage-card').forEach(element => {
                        element.classList.remove('loading');
                    });
                }
            }).catch(error => {
                console.error('Error:', error);
                document.querySelectorAll('.coverage-card').forEach(element => {
                    element.classList.remove('loading');
                });
            });
        },
        createPetElem(context, data) {
            const $fs = new Funnel({ ctx: context });
            const reqType = $fs.getReqType(puid);
            const $endpoint = `/api?req=${reqType}&action=add-pet`;
            $.ajax({
                type: 'POST',
                url: $endpoint,
                data: data.payload,
                beforeSend: function () {
                    context.commit('SET_SAVING_STATUS', true);
                },
                success: function (res) {
                    console.log('Pet created ', res);
                    if (!Utils.isEmpty(res) && Object.keys(res).length > 0) {
                        if (Object.keys(res.data).length > 0) {
                            $fs.commitMutations(res.data);
                        }
                        if (Object.keys(res.actions).length > 0) {
                            if (!Utils.isEmpty(res.actions.redirect)) {

                                const pet = new Pet({ ctx: context });
                                const petCount = pet.getPetsCount();
                                pet.createPetAdHocSeq(petCount);

                                context.commit('UPDATE_FUNNEL_ELEM', { iuid: 'in_new_pet', key: 'loading', val: false });
                                router.push(res.actions.redirect.url).catch(() => { });
                            }
                        }
                    }
                    context.commit('SET_SAVING_STATUS', false);
                },
                error: function () {
                    context.commit('SET_SAVING_STATUS', false);
                }
            });
        },
        editPetElem(context, data) {
            console.log('editPetElem: data', data);
            const $fs = new Funnel({ ctx: context });
            const reqType = $fs.getReqType(puid);
            const $endpoint = `/api?req=${reqType}&action=edit-pet`;
            $.ajax({
                type: 'POST',
                url: $endpoint,
                data: data,
                beforeSend: function () {
                    context.commit('SET_SAVING_STATUS', true);
                },
                success: function (res) {
                    console.log('Pet edited ', res);
                    if (!Utils.isEmpty(res) && Object.keys(res).length > 0 && res.error === undefined) {
                        if (Object.keys(res.data).length > 0) {
                            $fs.commitMutations(res.data);
                        }
                        if (Object.keys(res.actions).length > 0) {
                            if (!Utils.isEmpty(res.actions.redirect)) {
                                router.push(res.actions.redirect.url).catch(() => { });
                            }
                        }
                    }
                    context.commit('SET_SAVING_STATUS', false);
                },
                error: function () {
                    context.commit('SET_SAVING_STATUS', false);
                }
            });
        },
        deletePetElem(context, data) {
            console.log('deletePetElem: data', data);
            const $fs = new Funnel({ ctx: context });
            const reqType = $fs.getReqType(puid);
            const $endpoint = `/api?req=${reqType}&action=delete-pet&petNo=${data.payload.data.no}`;
            $.ajax({
                type: 'POST',
                url: $endpoint,
                data: data,
                beforeSend: function () {
                    context.commit('SET_SAVING_STATUS', true);
                },
                success: function (res) {
                    console.log('Pet deleted ', res);
                    if (res != null && Object.keys(res).length > 0 && res.error === undefined) {
                        if (Object.keys(res.data).length > 0) {
                            $fs.commitMutations(res.data);
                        }
                        if (Object.keys(res.actions).length > 0) {
                            if (!Utils.isEmpty(res.actions.redirect)) {
                                router.push(res.actions.redirect.url).catch(() => { });
                            }
                        }
                    }
                    context.commit('SET_SAVING_STATUS', false);
                },
                error: function () {
                    context.commit('SET_SAVING_STATUS', false);
                }
            });
        }
    }
}